import { Locale } from 'date-fns';
import { enGB as dateFnsEnGB } from 'date-fns/locale/en-GB';
import { enUS as dateFnsEnUs } from 'date-fns/locale/en-US';
import { es as dateFnsEsEs } from 'date-fns/locale/es';
import { fr as dateFnsfrFr } from 'date-fns/locale/fr';
import { ptBR as dateFnsPtBR } from 'date-fns/locale/pt-BR';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Import all locales
import enGB from './en-GB.json';
import enUS from './en-US.json';
import esES from './es-ES.json';
import frFR from './fr-FR.json';
import ptBR from './pt-BR.json';

enum Languages {
  'pt-BR' = 'pt-BR',
  'en-US' = 'en-US',
  'en-GB' = 'en-GB',
  'es-ES' = 'es-ES',
  'fr-FR' = 'fr-FR',
}

const languageFlags: Record<Languages, string> = {
  [Languages['pt-BR']]: 'BR',
  [Languages['en-US']]: 'US',
  [Languages['en-GB']]: 'GB',
  [Languages['es-ES']]: 'ES',
  [Languages['fr-FR']]: 'FR',
};

const resources: Record<Languages, { translation: object }> = {
  'en-US': {
    translation: enUS.translation,
  },
  'en-GB': {
    translation: enGB.translation,
  },
  'pt-BR': {
    translation: ptBR.translation,
  },
  'es-ES': {
    translation: esES.translation,
  },
  'fr-FR': {
    translation: frFR.translation,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: Object.keys(resources),
    fallbackLng: 'en-US',
    detection: {
      order: ['cookie', 'navigator'],
      caches: ['cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

function getDateFnsLocale() {
  const map: Record<Languages, Locale> = {
    [Languages['en-US']]: dateFnsEnUs,
    [Languages['en-GB']]: dateFnsEnGB,
    [Languages['es-ES']]: dateFnsEsEs,
    [Languages['pt-BR']]: dateFnsPtBR,
    [Languages['fr-FR']]: dateFnsfrFr,
  };

  return map[i18n.language as Languages];
}

export default i18n;
export { Languages, languageFlags, getDateFnsLocale };
